import './CategoryTiles.css'
import { Link } from 'react-router-dom'
import Carousel from './Carousel'
import { useCategories } from '../hooks/useSiteData'

export default function CategoryTiles() {
  const cats = useCategories()
  // same order as set in the admin (lowest display order first)
  const sorted = [...cats].sort((a, b) => (Number(a.sort_order) || 0) - (Number(b.sort_order) || 0))
  return (
    <Carousel label="categories">
      {sorted.map((c, i) => (
        <Link
          key={c.id}
          className={`tile${c.image_url ? '' : ' tile--plain'}`}
          to={`/shop?category=${encodeURIComponent(c.name)}`}
          aria-label={`Shop ${c.name}`}
          // categories without a photo get a navy tile; each one is shifted slightly in hue
          style={c.image_url ? undefined : { '--hue': 214 + ((i * 7) % 28) }}
        >
          {c.image_url ? (
            <span className="tile__media" style={{ backgroundImage: `url("${c.image_url}")` }} />
          ) : (
            <span className="tile__initial" aria-hidden="true">{c.name.trim().charAt(0)}</span>
          )}
          <span className="tile__shade" />
          <span className="tile__body">
            <span className="tile__text">
              <strong>{c.name}</strong>
              <i className="tile__rule" />
            </span>
            <span className="tile__go" aria-hidden="true">
              <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M5 12h14M13 6l6 6-6 6" />
              </svg>
            </span>
          </span>
        </Link>
      ))}
    </Carousel>
  )
}